import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.DASHBOARD.TEXT',
    icon: 'ri-dashboard-line',
    link: '/',
  },
  {
    id: 2,
    label: 'MENUITEMS.CASH_REPORTING.TEXT',
    icon: 'ri-exchange-funds-line',
    link: '/cash-reporting',
  },
  {
    id: 3,
    label: 'MENUITEMS.CASH_ANALYSIS.TEXT',
    icon: 'ri-bar-chart-grouped-fill',
    link: '/cash-analysis',
  },
  {
    id: 4,
    label: 'MENUITEMS.TRANSACTIONS.TEXT',
    icon: 'ri-grid-line',
    link: '/transactions',
  },
  {
    id: 5,
    label: 'MENUITEMS.PAYMENTS.TEXT',
    icon: 'bx bx-credit-card',
    link: '/payments',
  },
  {
    id: 6,
    label: 'MENUITEMS.BENEFICIARY.TEXT',
    icon: 'mdi mdi-account-group-outline',
    link: '/beneficiary',
  },
  {
    id: 7,
    label: 'MENUITEMS.FORECASTING.TEXT',
    icon: 'ri-line-chart-line',
    link: '/forecasting',
    badge: {
      variant: 'bg-phosphoric text-black',
      text: 'COMMON.SOON',
    },
    disabled: true
  },
  {
    id: 8,
    label: 'MENUITEMS.RECONCILIATION.TEXT',
    icon: 'ri-donut-chart-line',
    link: '/reconciliation',
    badge: {
      variant: 'bg-phosphoric text-black',
      text: 'COMMON.SOON',
    },
    disabled: true
  },
  {
    id: 9,
    label: 'MENUITEMS.IMPORT.TEXT',
    icon: 'ri-download-2-line',
    link: '/import-management',
  },
  // {
  //   id: 7,
  //   label: 'MENUITEMS.IMPORT.TEXT',
  //   icon: 'ri-download-2-line',
  //   link: '/import',
  // },
  // {
  //   id: 8,
  //   label: 'MENUITEMS.SETTING.TEXT',
  //   icon: 'ri-settings-5-line',
  //   link: '/setting',
  // },
  // {
  //   id: 9,
  //   label: 'MENUITEMS.DEVELOPER.TEXT',
  //   icon: 'ri-code-fill',
  //   link: '/developer',
  // },
];
